import React from 'react' ;
import axios from "../../Uri";
//Get All Buildings  .
export const GetAllBuildings = () => {
    return axios.get("bed/getAllBuildings");
};

export const CurrentMonthCheckout = () => {
    return axios.get("/profiles/currentMonthCheckout")
}

export const CurrentMonthCheckIn = () => {
    return axios.get("/profiles/currentMonthCheckIn")
}